@if (!_readOnly) {
  <div
    style="width:600px"
    class="mt-3"
    >
    @if (showTemplates) {
      <div
        class="mb-4">
        <label>{{ 'MANAGEMENT.WORKFLOW.RULE-SELECT-TEMPLATE' | translate }}</label>
        <div class="select is-secondary is-medium offest-select">
          <select
            [(ngModel)]="selectedTemplateUId"
            (change)="templateSelected()">
            @for (template of templates; track template.uId) {
              <option
                [ngValue]="template.uId">
                {{ template.name }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    @if (showSubjectInput) {
      <div
        class="mb-4">
        <label>{{ 'COMMUNICATIONS.SUBJECT' | translate }}</label>
        <div>
          <input
            (ngModelChange)="subjectChanged($event)"
            class="input is-small is-fullwidth"
            type="text"
            placeholder="{{ 'COMMUNICATIONS.SUBJECT' | translate }}"
            [(ngModel)]="selectedSubject" />
        </div>
      </div>
    }
    @if (showNotificationMessage) {
      <div
        class="mb-4">
        <label>{{ 'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate }}</label>
        <quill-editor
          [styles]="{ height: '104px' }"
          [modules]="editorModules"
          [(ngModel)]="notificationMessage"
          (onContentChanged)="onMessageChanged($event)"
        (onEditorCreated)="editorCreated($event)"></quill-editor>
      </div>
    }
    @if (showSmsNotificationMessage) {
      <div class="mb-4">
        <label>{{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}</label>
        <textarea
          class="input is-small is-fullwidth sms-message"
          type="text"
          cols="8"
          placeholder="{{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}"
          (keyup)="smsNotificationMessageChanged($event)"
        [(ngModel)]="smsNotificationMessage"></textarea>
      </div>
    }
    @if (selectedTemplate && showRecipientSelect) {
      <topo-comms-recipients-selection
        [includeUsers]="true"
        [includeGroups]="false"
        [includeDistro]="true"
        [includeDatasets]="true"
        [showAddedRecipients]="true"
        [addToTotalRecipients]="false"
        (selectedRecipientsChanged)="selectedRecipientsChanged($event)"
      [toRecipientSettings]="recipientSettings"></topo-comms-recipients-selection>
    }
  </div>
}

@if (_readOnly) {
  <div
  [innerHtml]="action?.displayText | safeHtml"></div>
}
